export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;

export const MAX_PHONE_DIGITS = {
  PE: {
    min: 9,
    max: 9,
  },
};
